import React from 'react'
import './Facility.css'
import Header_Banner from '../common-components/common_banner/header_banner/Header_Banner'
import Complete_Medical from '../common-components/common_banner/complete_medical/Complete_Medical'
import { Col, Container, Row } from "react-bootstrap";
import Service_Card from "../common-components/common_card/service_card/Service_Card";
import { useNavigate } from "react-router-dom";

const Facility = () => {

    const services = [
        {
            id: 1, // Added ID for navigation
            title: "Physical Exam (Height, Weight, BMI & Vitals)",
            icon: "/assets/images/services/bottom-img.png",
            hoverImg: "/assets/images/common_service_card/img-1.png",
            description:
                "A Physical Exam is a basic health assessment.",
            list: [
                "Height: Measured without footwear to assess physical eligibility and calculate BMI.",
                "Weight: Measured in kilograms to evaluate nutritional status and overall health",
                "Body Mass Index (BMI): Calculates weight in relation to height to identify underweight, normal weight, overweight, or obesity.",
                "Vital Signs: Assess essential body functions, including blood pressure, heart rate, respiratory rate, body temperature, and oxygen saturation (SpO₂)."
            ],
        },
        {
            id: 2,
            title: "Eye and Colour Vision Tests",
            icon: "/assets/images/services/bottom-img.png",
            hoverImg: "/assets/images/common_service_card/img-2.png",
            description:
                "conducted to assess a person’s visual clarity and ability to distinguish colours, which are essential for safety-critical duties and daily work performance.",
            list: [
                "Distant and Near Vision: Checks for clear vision required for navigation and onboard duties.",
                "Color Vision (Ishihara Test): Ensures ability to distinguish colors critical for marine safety signals.",
                "Night Vision Test (if required): Assesses low-light vision for safe operations during night shifts.",
            ]
        },
        {
            id: 3,
            title: "General Diagnostic Facility",
            icon: "/assets/images/services/bottom-img.png",
            hoverImg: "/assets/images/common_service_card/img-3.png",
            description:
                "",
            list: [
                "ECG (Electrocardiogram):-Measures the electrical activity of the heart to detect arrhythmias, heart disease, or other cardiac issues.",
                "Audiometry (Hearing Test):-Assesses hearing ability across different frequencies to ensure safe communication and alertness. ",
                "Spirometry:-Measures lung function and airflow to detect respiratory conditions and ensure fitness for physically demanding roles.",
            ]
        },
        {
            id: 4,
            title: "Special Diagnostic Facility (NABH Approved Diagnostic Centers)",
            icon: "/assets/images/services/bottom-img.png",
            hoverImg: "/assets/images/common_service_card/img-4.png",
            description:
                "",
            list: [
                "2D Echo: Checks heart structure and function to ensure the candidate’s heart is healthy for physically demanding marine duties",
                "X-Ray: Provides internal imaging of bones, chest, and organs to identify injuries, infections, or abnormalities",
                "Cardiac Stress Test: Assesses how the heart performs under physical exertion, ensuring safety during onboard operations or emergency situations.",
                "USG Abdomen & Pelvis: Examines internal organs (liver, kidneys, bladder, etc.) to detect conditions."
            ]
        },
        {
            id: 5,
            title: "Drug & Alcohol Testing",
            icon: "/assets/images/services/bottom-img.png",
            hoverImg: "/assets/images/common_service_card/img-5.png",
            description:
                "We provide professional drug and alcohol testing for marine, naval, offshore, and industrial personnel, conducted in line with international safety and regulatory standards",
            list: [
                "Services Include: Alcohol and prohibited substance screening, Pre-employment, rejoining, random, and periodic testing, Fit-to-work and medical fitness support, Compliance with maritime, offshore, and oil & gas guidelines",
                "Policy & Compliance:Testing follows unannounced and unconditional policies in accordance with international standards, including OCIMF requirements. All required consent and declarations are obtained.",
                "Why It Matters: Ensures safety, fitness for duty, and compliance with industry standards.",
            ]
        },
        {
            id: 6,
            title: "Mental Health & Psychological Evaluation",
            icon: "/assets/images/services/bottom-img.png",
            hoverImg: "/assets/images/common_service_card/img-6.png",
            description:
                "Our panel includes expert clinical psychologists who carefully assess and cross-check each patient’s condition to provide accurate and effective psychological services",
            list: [
                "Services Include: Evaluation of stress tolerance, emotional stability, and cognitive function. Screening for anxiety, depression, or other psychological conditions. Assessment of decision-making and problem-solving abilities under pressure. Confidential and structured interviews and standardized tests. Recommendations for fit-to-work certification based on assessment results.",
                "Why It Matters: Ensures that seafarers are mentally resilient, alert, and capable of handling demanding offshore operations, emergencies, and team responsibilities safely.",
            ]
        },
    ];


    return (
        <>
            <section className='services'>
                <Header_Banner
                    imgSrc={"/assets/images/facility/banner.jpg"}
                    title_text="Facilities"
                    breadcrumbs={[
                        { label: "Home", link: "/", isActive: false },
                        { label: "Facilities", link: "", isActive: true },
                    ]}
                />


                <Container className="mt-5">

                    <div className="servicetitlediv">
                        <h2>Our Health Facilities</h2>
                        <p>At <b>Shore Clinic</b>, we provide <b>comprehensive DG-Approved marine medical examinations</b> for <b>seafarers</b>, ensuring full compliance with <b>DG Shipping regulations and ILO (MLC 2006) standards</b>. Our services are designed to <b>certify fitness for sea duty</b>, promote <b>crew health and safety</b>, and support <b>national and international shipping requirements.</b></p>
                    </div>

                    <Row>
                        {services.map((service, index) => (
                            <Col lg={4} md={6} sm={12} className="mb-4" key={index}>
                                <div className="servcard"
                                // onClick={() => handleBlogClick(service.id)}
                                >
                                    <Service_Card {...service} />
                                </div>
                            </Col>
                        ))}
                    </Row>

                </Container>

                <Complete_Medical />

            </section>

        </>
    )
}

export default Facility